module.exports = __webpack_public_path__ + "static/media/Badge_PngMarqueParcours_LRP.1c8e3b8c.png";